const groupPrefix = 'bookings'

export const apiBooking = {
	fetchBooking: async (uuid: string) => {
		const { data } = await apiCommon<IBooking>(`${groupPrefix}/${uuid}`, {
			method: 'GET',
		})

		return Booking(data)
	},

	createBooking: async (request: IBookingStoreRequest, locale: string) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		} else if (locale === 'en') {
			lang = 'en'
		}

		// currency header
		const currency = useCookie('currency').value

		const { data } = await apiCommon<IBooking>(
			groupPrefix,
			{
				method: 'POST',
				body: request,
			},
			lang,
			currency || 'PLN',
		)

		return Booking(data)
	},

	updateBooking: async (
		request: IBookingStoreRequest,
		uuid: string,
		locale: string,
		signal: AbortSignal,
		existingBooking: IBookingModel | null,
	) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		} else if (locale === 'en') {
			lang = 'en'
		}

		// currency header
		const currency = useCookie('currency').value

		const data = await apiCommon<IBooking>(
			`${groupPrefix}/${uuid}`,
			{
				method: 'PUT',
				body: request,
				signal,
			},
			lang,
			currency || 'PLN',
		)

		return data?.data ? Booking(data?.data) : existingBooking
	},

	finalizeBooking: async (uuid: string, request: IBookingFinalizeRequest, locale: string) => {
		// currency header
		const currency = useCookie('currency').value

		const response = await apiCommon<{ data: IBooking; gateway_url: string }>(
			`${groupPrefix}/${uuid}/finalize`,
			{
				method: 'PUT',
				body: request,
			},
			locale,
			currency || 'PLN',
		)

		return {
			booking: Booking(response.data),
			gateway_url: response.gateway_url,
		}
	},
}
